module.exports = "/_next/static/images/d3f642b42a54bd6cce2bd2e18e49aca5-LogoLiverpool.jpg.webp";